// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Cbm4","bigColWidth":"Table_bigColWidth__1aeM8","biggerColWidth":"Table_biggerColWidth__1y6yl","row":"Table_row__q7VII","col":"Table_col__2ZFbU"};